import { BaseSensorWebController } from '../../base/controller/BaseSensorWebController';
import { AzureCWSensorComponent } from '../component/AzureCWSensorComponent';
import { AzureCWSensorView } from '../view/AzureCWSensorView';
import { templateAzureCWSensor } from '../view/template';
import { IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { SensorEvent } from '../../types/sensor-type';
import { SensorEnabledStatus } from '../../../common/types';

export class AzureCWSensorController extends BaseSensorWebController {
  constructor(component: AzureCWSensorComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: AzureCWSensorView,
      viewTemplate: templateAzureCWSensor,
    });
  }
  public component: AzureCWSensorComponent;
  public view: AzureCWSensorView;
  public viewConstructor: typeof AzureCWSensorView;

  public isSensorEnabled(): boolean {
    return true;
  }

  async getDataForView(): Promise<any> {
    if (!this.component.getSensorId()) {
      return {};
    }

    const data = await this.dependencies.api.clients.SensorsIntegrations.getSensorById({
      sensorId: this.component.getSensorId(),
    });
    data.enabledStatus = SensorEnabledStatus.ENABLED;
    return data;
  }

  computeEventListeners(): IListenerConfig[] {
    return super.computeEventListeners().concat([
      {
        element: this.view.dom.$applicationID,
        event: SensorEvent.change,
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$tenantID,
        event: SensorEvent.change,
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$clientSecret,
        event: SensorEvent.change,
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$subscriptionID,
        event: SensorEvent.change,
        callback: this.inputChanged,
      },
    ]);
  }

  public resetData(): void {
    super.resetData();
    this.view.dom.$applicationID.resetField();
    this.view.dom.$tenantID.resetField();
    this.view.dom.$clientSecret.resetField();
    this.view.dom.$subscriptionID.resetField();
  }
}
